import {openAuthenticateModal} from '@Modals/authenticate-modal/authenticate-modal-library';

export const MAX_ACCOUNT_BUTTONS_TO_SHOW = 5;
export const WIZARD_HEADER_CLASS = 'js-social-media-wizard-header js-designs-content-header';

export const openSocialMediaWizardAuthenticateModal = (onLoginSuccess: () => void): void => {
  openAuthenticateModal({
    fbPermissions: '',
    signupSource: 'social-media-wizard',
    panelText: window.i18next.t('pmwjs_make_account_to_publish_post'),
    panelSubtext: window.i18next.t('pmwjs_login_publishing_promotion_subtext'),
    onLoginSuccess: (): Promise<void> => {
      onLoginSuccess();
      return Promise.resolve();
    },
  });
};
